import {
  Grid,
  Card,
  Box,
  CardMedia,
  CardContent,
  Typography,
  CardActions,
  IconButton,
} from "@mui/material";
import { title } from "process";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import FavoriteIcon from "@mui/icons-material/Favorite";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import Parse from "../../API/ParseServer";
import styles from "./ArtworkCard.module.css";
const ArtworkCard: React.FC<{
  artwork: any;
  basket: any;
  artworkChangeHandler: any;
  artworkQuantities: any;
  grid: any;
}> = (props) => {
  const title = props.artwork.get("title");
  const objectId = props.artwork.id;
  const artist = props.artwork.get("artist");
  const price = props.artwork.get("price");
  const width = props.artwork.get("width");
  const height = props.artwork.get("height");
  const thumbnail = props.artwork.get("thumbnail");
  const thumbnailUrl = thumbnail ? thumbnail._url : "";
  const [inputQuantity, setInputQuantity] = useState(0);
  const [quantity, setQuantity] = useState(0);
  const [reservedQuantity, setReservedQuantity] = useState(0);
  const [successMessage, setSuccessMessage] = React.useState("");
  const [quantityloading, setQuantityloading] = useState(false);
  const [itemId, setItemId] = useState("");
  const [isLiked, setIsLiked] = useState();
  const uid = function () {
    return (
      Date.now().toString(36) +
      Math.floor(
        Math.pow(10, 12) + Math.random() * 9 * Math.pow(10, 12)
      ).toString(36)
    );
  };
  const guestId = localStorage.getItem("guestId")
    ? localStorage.getItem("guestId")
    : uid();
  const [basketLoading, setBasketLoading] = useState(false);
  useEffect(() => {
    const user = Parse.User.current();

    const fetchBasket = async () => {
      setBasketLoading(true);
      if ((user || localStorage.getItem("guestId")) && props.basket) {
        try {
          if (
            props.basket
              .get("items")
              .find(
                (item: any) =>
                  item.type === "Artwork" &&
                  item.artwork.id === props.artwork.id
              )
          ) {
            setInputQuantity(
              props.basket
                .get("items")
                .find(
                  (item: any) =>
                    item.type === "Artwork" &&
                    item.artwork.id === props.artwork.id
                ).quantity
            );
            setItemId(
              props.basket
                .get("items")
                .find(
                  (item: any) =>
                    item.type === "Artwork" &&
                    item.artwork.id === props.artwork.id
                ).itemId
            );
          } else {
            setInputQuantity(0);
            setItemId("");
          }
          // console.log(
          //   basket
          //     .get("items")
          //     .find((item: any) => item.artwork.id === artworkId).quantity
          // );
        } catch (error) {
          console.error("Error fetching basket:", error);
        } finally {
          setBasketLoading(false);
        }
      } else {
        setBasketLoading(false);
      }
    };
    fetchBasket();
    setQuantity(props.artwork.get("quantity"));
    setReservedQuantity(props.artwork.get("reservedQuantity"));

    if (user) {
      setIsLiked(
        props.artwork.get("likeUsers")
          ? props.artwork.get("likeUsers").includes(user.id)
          : false
      );
    }
  }, [props, inputQuantity]);
  const quantityDecHandler = async () => {
    setQuantityloading(true);
    setSuccessMessage("");

    const user = Parse.User.current();
    let response;
    if (inputQuantity !== 0) {
      try {
        if (user)
          response = await Parse.Cloud.run("addToBasket", {
            user: user.id,
            artworkId: props.artwork.id,
            quantity: inputQuantity - 1,
            frameId: "",
            specifications: {
              mountboard: {},
              width: width,
              height: height,
            },
            type: "Artwork",
            itemId: itemId ? itemId : "",
          });
        else {
          response = await Parse.Cloud.run("addToBasket", {
            user: guestId,
            artworkId: props.artwork.id,
            quantity: inputQuantity - 1,
            frameId: "",
            specifications: {
              mountboard: {},
              width: width,
              height: height,
            },
            type: "Artwork",
            itemId: itemId ? itemId : "",
          });
          if (guestId) localStorage.setItem("guestId", guestId);
        }
      } catch (error) {
        console.log(error);
      } finally {
        if (response) {
          console.log(response);
          setTimeout(() => {
            setInputQuantity((current) => current - 1);
            setSuccessMessage("Item removed");
          }, 200);
          setTimeout(() => {
            setSuccessMessage("");
          }, 1000);
          // setItemId(response);
        }
        setQuantityloading(false);
        props.artworkChangeHandler();
      }
    } else setQuantityloading(false);
  };

  const quantityIncHandler = async () => {
    setSuccessMessage("");
    setQuantityloading(true);
    const user = Parse.User.current();
    let response;
    if ((props.artworkQuantities[props.artwork.id] || 0) < quantity) {
      try {
        if (user)
          response = await Parse.Cloud.run("addToBasket", {
            user: user.id,
            artworkId: props.artwork.id,
            quantity: inputQuantity + 1,
            frameId: "",
            specifications: {
              mountboard: {},
              width: width,
              height: height,
            },
            type: "Artwork",
            itemId: itemId ? itemId : "",
          });
        else {
          await Parse.Cloud.run("addToBasket", {
            user: guestId,
            artworkId: props.artwork.id,
            quantity: inputQuantity + 1,
            frameId: "",
            specifications: {
              width,
              height,
              mountboard: {},
            },
            type: "Artwork",
            itemId: itemId ? itemId : "",
          });
          if (guestId) localStorage.setItem("guestId", guestId);
        }
      } catch (error) {
        console.log(error);
      } finally {
        if (response) {
          setTimeout(() => {
            setInputQuantity((current) => current + 1);
            setSuccessMessage("item added");
          }, 200);

          setTimeout(() => {
            setSuccessMessage("");
          }, 1000);
        }
        setQuantityloading(false);
        props.artworkChangeHandler();
      }
    } else setQuantityloading(false);
  };
  const [likeError, setLikeError] = useState("");
  const likeHandler = async () => {
    const user = Parse.User.current();
    if (user) {
      let response: any;
      try {
        response = await Parse.Cloud.run("toggleArtworkLike", {
          artworkId: props.artwork.id,
          userId: user.id,
        });
      } catch (error: any) {
        console.error(error.message);
        alert(error.message);
      } finally {
        if (response) {
          // setIsLiked(response.isLiked);
          setTimeout(() => {
            setIsLiked(response.isLiked);
          }, 200);
          // setItemId(response);
        }

        // props.artworkChangeHandler();
      }
    } else {
      setLikeError("You need to login first!");
      setTimeout(() => {
        setLikeError("");
      }, 1000);
    }
  };
  function truncate(str: string, maxLength: number) {
    return str.length > maxLength
      ? str.substring(0, maxLength - 3) + "..."
      : str;
  }
  function addCommas(num: number) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  return (
    <Grid
      item
      xs={12}
      sm={6}
      md={4}
      lg={props.grid}
      sx={{ position: "relative" }}
    >
      <Card
        sx={{
          backgroundColor: "transparent",
          // border: "1px solid #b4b4b4",
          boxShadow: "0px 2px 10px #c9c9c9ff",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <Link to={`/artwork/${objectId}`} key={title}>
          <Box
            sx={{
              width: "100%",
              aspectRatio: 1,
              backgroundColor: "white",
              display: "flex",
              alignItems: "center",
            }}
          >
            <CardMedia
              component="img"
              // height="5rem"
              image={thumbnailUrl}
              alt={title}
              sx={{
                width: "100%",
                objectFit: "contain",
                aspectRatio: 1,
                p: 1,
                boxShadow: "0px 2px 10px #c9c9c9ff",
              }}
            />
          </Box>
          <CardContent sx={{ px: 2 }} style={{ paddingBottom: "4px" }}>
            <Typography variant="body2" component="h1">
              {truncate(title, 30)}
            </Typography>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Typography variant="subtitle2" color="text.secondary">
                By {artist}
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                flexWrap: "wrap",
              }}
            >
              <Typography variant="subtitle1" color="text.secondary">
                {props.artwork.get("framingImage") ? "Painting" : ""} {width}x
                {height}cm
              </Typography>
              {quantity > 0 ? (
                <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                  £{addCommas(price)}
                </Typography>
              ) : (
                <Typography
                  variant="subtitle1"
                  // color="text.secondary"
                  sx={{ color: "red" }}
                >
                  Sold!
                </Typography>
              )}
              {/* {quantity > 0 && (
                <Typography variant="caption" color="text.secondary">
                  Rent for £ /mo
                </Typography>
              )} */}
            </Box>
          </CardContent>
        </Link>
        <CardActions disableSpacing sx={{ borderTop: "1px solid #b4b4b4" }}>
          {isLiked ? (
            <IconButton aria-label="remove to favorites" onClick={likeHandler}>
              <FavoriteIcon sx={{ color: "#8d462b" }} />
            </IconButton>
          ) : (
            <IconButton aria-label="add to favorites" onClick={likeHandler}>
              <FavoriteBorderOutlinedIcon />
            </IconButton>
          )}
          <Box sx={{ ml: "auto", display: "flex", alignItems: "center" }}>
            {successMessage && (
              <Typography variant="caption" sx={{ textAlign: "center", mr: 1 }}>
                {successMessage}
              </Typography>
            )}
            {inputQuantity > 0 ? (
              <Box sx={{ display: "flex", gap: 1 }}>
                <button
                  className={
                    inputQuantity === 0
                      ? styles["quantity-disable"]
                      : styles["quantity-button"]
                  }
                  onClick={() => {
                    if (!(quantityloading || basketLoading))
                      quantityDecHandler();
                  }}
                  disabled={
                    inputQuantity === 0 || quantityloading || basketLoading
                  }
                >
                  -
                </button>
                <Typography
                  sx={{
                    border: "2px solid #8d462b",
                    borderRadius: 2,
                    // p: "2px 10px",
                    py: "2px",
                    width: "2.3rem",
                    textAlign: "center",
                    backgroundColor: "white",
                  }}
                >
                  {inputQuantity}
                </Typography>
                <button
                  className={
                    (props.artworkQuantities[props.artwork.id] || 0) >= quantity
                      ? styles["quantity-disable"]
                      : styles["quantity-button"]
                  }
                  onClick={() => {
                    if (!(quantityloading || basketLoading))
                      quantityIncHandler();
                  }}
                  disabled={
                    (props.artworkQuantities[props.artwork.id] || 0) >=
                      quantity ||
                    quantityloading ||
                    basketLoading
                  }
                >
                  +
                </button>
              </Box>
            ) : (
              <IconButton
                aria-label="add to favorites"
                onClick={quantityIncHandler}
                disabled={quantity <= 0 || quantityloading || basketLoading}
              >
                <ShoppingBagOutlinedIcon />
              </IconButton>
            )}
          </Box>
        </CardActions>
      </Card>
      {likeError && (
        <Typography
          variant="caption"
          sx={{ position: "absolute", backgroundColor: "white" }}
        >
          {likeError}
        </Typography>
      )}
    </Grid>
  );
};
export default ArtworkCard;
